import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import './ContainedHero.scss';
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldTxtSubTitle: string;
        fieldObjectImgMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
        fieldObjectHeroItemStyle: Array<{entity: Array}>;
    }
}

class ContainedHeroQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphByRevisionId($id: String!) {
    paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentContainedHero {
          fieldTxtHeadline
          fieldTxtSubTitle
          fieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
            }
          }
          fieldObjectHeroItemStyle {
              ${fieldObjectSectionStyle}
          }
        }
      }
    }
  }
}
`;

const ContainedHero = ({id, markComponentLoadedAs}) => (
    <ContainedHeroQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const styles = fieldObjectSectionStyleCss(field.fieldObjectHeroItemStyle);

            markComponentLoadedAs(id, true);

            // Require Hero image to Render
            if (!(field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url)) return null;

            return (
                <section className={`containedHero${styles.classNames}`} style={styles.css} id={styles.id}>
                    <div className="container containedHero__container">
                        <header className="containedHero__header">
                            {field.fieldTxtHeadline ? (
                                <h1 className="containedHero__title">{field.fieldTxtHeadline}</h1>
                            ) : null}

                            {field.fieldTxtSubTitle ? (
                                <h2 className="containedHero__subtitle">{field.fieldTxtSubTitle}</h2>
                            ) : null}
                        </header>

                        <div className="containedHero__image">
                            <img src={field.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                        </div>
                    </div>
                </section>
            );
        }}
    </ContainedHeroQuery>
);

ContainedHero.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
};

ContainedHero.defaultProps = {
    componentIndex: null
};

export default ContainedHero;



// WEBPACK FOOTER //
// ./frontend/components/ContainedHero/ContainedHero.jsx